module.exports = __webpack_public_path__ + "static/media/Migration_Loader.d31d3d33.gif";